import { gql } from '@apollo/client';

const DIGITAL_WALLET_INFO_QUERY = gql`
  query DigitalWalletInfo($accountId: String!, $customerId: String!) {
    account(accountId: $accountId, customerId: $customerId) {
      id
      digitalWallet {
        id: accountId
        info {
          status
          wallets {
            description
            dnitheId
            termsAndConditions
            tokenNumber
            tokenRequestorId
            tokenType
            status
          }
        }
        events {
          date
          indicator
          reason
          status
          time
          tokenNumber
          tokenRequesterId
          vendor
        }
      }
      checkEligibility(eligibilityType: DIGITAL_WALLET_TOKEN_ACTIVATION) {
        eligibility {
          eligible
          reasons {
            code
            description
            pass
          }
        }
      }
    }
  }
`;

export { DIGITAL_WALLET_INFO_QUERY };
